<div style="height: 100%;">

    <form [formGroup]="searchForm" class="w-100">
        <div class="top-section">
            <div [class.collapsed]="isSearchFocused" [ngClass]="{'expanded': expandStatusList}"
                class="ordercount-section container-fluid">

                <div *ngIf="isCountLoading; else realCountContent" class="d-flex align-items-center justify-content-start flex-wrap" style="row-gap: 15px; column-gap: 6px;">
                    <ng-container *ngFor="let _ of [].constructor(6)">
                        <div class="p-0" style="width:32%">
                            <div class="d-inline-flex align-items-center justify-content-between rounded-pill p-1 w-100 skeleton-box"
                                style="border: 2px solid #e0e0e0;">
                                <span class="skeleton-text short me-2" style="margin: 0 6px;"></span>
                                <span class="skeleton-box" style="min-width:48px; height:28px; border-radius:14px;"></span>
                            </div>
                        </div>
                    </ng-container>
                </div>
                <ng-template #realCountContent>
                    <div class="d-flex align-items-center justify-content-start flex-wrap"
                        style="row-gap: 15px; column-gap: 6px;">
                        <ng-container *ngFor="let status of orderStatuses">
                            <div class="p-0" style="width:32%" (click)="addStatusFilter(status)">
                                <div class="d-inline-flex align-items-center justify-content-between rounded-pill p-1 w-100"
                                    [ngStyle]="status.StatusLabel === workOrdersParams.statusType ? {'border': '2px solid ' + status.StatusColour,'background-color': status.StatusColour } : {'border': '2px solid ' + status.StatusColour}">
                                    <span class="me-2 small"
                                        style="font-size: 12px; margin: 0 6px; overflow: hidden; text-overflow: ellipsis;">{{status.MobStatusLabel}}</span>
                                    <span class="d-flex align-items-center justify-content-center "
                                        style="min-width: 48px; height: 28px; font-size:11.5px; line-height: 4.5; font-weight: 600; border-radius: 14px;"
                                        [ngStyle]="status.StatusLabel === workOrdersParams.statusType ? {'background-color': '#673AB7'} : {'background-color': status.StatusColour}">
                                        {{status.StatusCount}}
                                    </span>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </ng-template>

            </div>
            <div class="filter-section px-3 pb-2 pt-0 d-flex flex-column w-100">
                <div class="d-flex justify-content-center align-content-center pt-0" style="height: 25px;">
                    <div *ngIf="isSearchFocused" class="px-3 text-white" style="position: absolute; left: 0; margin-top: 5px; font-size: 14px;">In {{workOrdersParams.statusType}}</div>
                    <i class="bi bi-chevron-compact-down down-arrow"
                        (click)="isSearchFocused ? isSearchFocused = false : expandStatusList = !expandStatusList"
                        [class.rotated]="expandStatusList" style="color: #fff; font-size: 26px; margin-top: -7px;"></i>
                </div>
                <div class="d-flex w-100">
                    <div class="search-wrapper w-100">
                        <input id="search" class=" form-control search-input"
                            (focus)="[isSearchFocused = true, expandStatusList = false]" formControlName="search"
                            type="text" placeholder="Search" />
                        <button type="button" class="btn-clear-input" *ngIf="isSearchFocused"
                            (click)="clearSearch()">
                            &times;
                        </button>
                    </div>
                    <button *ngIf="!this.searchForm.get('search')?.value" type="button" class="btn filter-btn p-0 ml-1"
                        data-toggle="modal" data-target="#staticBackdrop">
                        <i class="bi bi-funnel-fill" style="color: #fff; font-size: 26px;"></i>
                    </button>
                </div>
            </div>
        </div>
        <div ngClass="filter-section"
            *ngIf="isFiltered===true && getActiveFilters().length > 0 && !this.searchForm.get('search')?.value"
            class="d-flex align-items-center justify-content-between"
            style="background-color: #ede7f6; padding: 4px 10px; gap: 6px;">
            <div class="d-flex flex-wrap" style="gap: 6px;">
                <span style="font-size: 13px; color: #673AB7;">Fltr:</span>
                <div *ngFor="let filter of getActiveFilters(); let i = index;"
                    class="d-flex align-items-center justify-content-center">
                    <span style="color: #333333; font-size: 13px;">{{ filter.display }} <span
                            *ngIf="i!==getActiveFilters().length-1">,</span> </span>
                </div>
            </div>
            <button type="button" class="btn ml-2 p-0 "
                style="background-color: #ede7f6;width: 40px; text-align: right;" (click)="removeAllFilter()">
                &times;
            </button>
        </div>
        <div ngClass="filter-section" *ngIf="this.searchForm.get('search')?.value && !clearFilters"
            class="d-flex align-items-center justify-content-between"
            style="background-color: #F06292; padding: 4px 10px; gap: 6px;">
            <div class="d-flex flex-wrap" style="gap: 6px;">
                <span style="font-size: 13px; color: #9C27B0 ;">Apld Fltr:</span>
                <div *ngFor="let filter of getActiveFilters(); let i = index;"
                    class="d-flex align-items-center justify-content-center">
                    <span style="color: white; font-size: 13px;">{{ filter.display }} <span
                            *ngIf="i!==getActiveFilters().length-1">,</span> </span>
                </div>
            </div>
            <button type="button" class="btn ml-2 pl-3"
                style="border-left: 0.1rem solid white; border-radius: 0px; color: white; font-weight: 700; font-size: 13px; padding-inline: 5px; padding-block: 0px;"
                (click)="clearAllFilters()">
                Clear
            </button>
        </div>
        <div ngClass="filter-section" *ngIf="this.searchForm.get('search')?.value && clearFilters"
            class="d-flex align-items-center justify-content-between" style="background-color: white;">
            <div class="d-flex flex-wrap">
                <span style="font-size: 13px; font-weight: 700; padding-left: 10px;">Revert to
                    previous filters</span>
            </div>
            <button type="button" class="btn mr-0 py-0" style="" (click)="applyAllFilters()">
                <i class="bi bi-arrow-counterclockwise py-0" style="font-size: 1.35rem;"></i>
            </button>
        </div>
    </form>


    <div class="list-container" [class.reduced-height]="isSearchFocused" id="main"
        [class.reduced-height-with-filter]="isSearchFocused && this.searchForm.get('search')?.value"
        [class.height-with-filter]="isFiltered===true && getActiveFilters().length > 0 && !this.searchForm.get('search')?.value">
        <ng-container>
            <div class="list-section pb-2">
                <ng-container *ngIf="msg">
                    <div class="d-flex justify-content-center align-items-center pt-4">{{msg}}</div>
                </ng-container>
                <ng-container *ngIf="!isLoading">
                    <div #scrollContainer infinite-scroll [infiniteScrollDistance]="scrollDistance"
                        [infiniteScrollUpDistance]="scrollUpDistance" [infiniteScrollThrottle]="throttle"
                        (scrolled)="onScroll()" [scrollWindow]="false" class="mt-1 px-2"
                        data-preserve-scroll
                        style="height: 100%;overflow-y: auto;">
                        <ng-container *ngFor="let order of workOrders">
                            <div class="my-1 d-flex workorder-card p-2" (click)="navigateToJobDetails(order.ID)">
                                <div class="d-flex flex-column first-section">
                                    <div class="d-flex flex-fill">
                                        <div class="flex-fill"
                                            style="border-radius: 6px; border-width: 0.01rem ; border-style: solid;"
                                            [ngStyle]="{ 'background-color': lightenColor(order.StatusColour,0.2) , 'border-color' : order.StatusColour}">
                                            <div
                                                class="d-flex flex-column justify-content-center align-items-center h-100">
                                                <div class="delivery-date d-flex flex-column align-items-center"
                                                    [ngStyle]="{'color': order.StatusColour}">
                                                    <div>{{order.DeliveredDate ? 'Delivered On' : 'Due On'}}</div>
                                                    <div class="day">{{getDay(order.DeliveryDate)}}</div>
                                                    <div style="text-transform: capitalize;">
                                                        {{getMonth(order.DeliveryDate)}}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="d-flex mt-1 footer" *ngIf="order.AssignedUser">
                                        <div class="d-flex align-self-center w-100 assigned-user-pill"
                                            style="height: 20px;"
                                            [ngStyle]="{ 'background-color': lightenColor(order.StatusColour,0.2) , 'border-color' : order.StatusColour}">
                                            <div class="d-flex align-items-center justify-content-center user-text-icon"
                                                [ngStyle]="{'background-color': order.StatusColour , 'border-color' : order.StatusColour}">
                                                {{
                                                order.AssignedUser.substring(0, 2).toUpperCase() }}</div>
                                            <div class="half-ellipsis text-center px-1"
                                                [ngStyle]="{'color': order.StatusColour}">
                                                {{order.AssignedUser}}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="w-100 overflow-hidden pl-2 d-flex flex-column">
                                    <div class="flex-fill" style="font-size: 0.85rem; line-height: 1.4;">
                                        <div class="d-flex justify-content-between">
                                            <div class="ellipsis-2-lines flex-shrink-1 pr-1">
                                                {{order.DeviceType}}
                                                <span *ngIf="order.DeviceType">,</span>
                                                {{order.Manufacture}}
                                            </div>

                                            <div *ngIf="order.PaymentStatus !== 'New'" class="d-flex flex-shrink-0" style="color:#fff;">
                                                <div *ngIf="order.PaymentStatus !== 'Paid'" class="payment-status-pill" style="background-color: yellowgreen;">
                                                    Par. | ₹<span *ngIf="order.paidAmount !== null && order.paidAmount !== undefined else loading">{{order.paidAmount}}</span> 
                                                    <ng-template #loading>
                                                        <span class="dot">•</span><span class="dot">•</span><span class="dot">•</span>
                                                    </ng-template>
                                                </div>
                                                <div *ngIf="order.PaymentStatus === 'Paid'" class="payment-status-pill" style="background-color: green;" >
                                                    Paid | ₹<span *ngIf="order.paidAmount !== null && order.paidAmount !== undefined else loading">{{order.paidAmount}}</span> 
                                                    <ng-template #loading>
                                                        <span class="dot">•</span><span class="dot">•</span><span class="dot">•</span>
                                                    </ng-template>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="w-100 ellipsis-1-lines"><span class="label">Issue:
                                            </span>{{order.WorkDescription}}</div>
                                        <div class="w-100 mt-1 d-flex" *ngIf="order.ContactPerson">
                                            <div class="contact-person mr-2 d-flex align-items-center"
                                                [ngStyle]="order.ShopName ? {'color': '#EC5228'} : {'color': '#673AB7'}">
                                                <div class="shop-customer-logo mr-1"
                                                    [ngStyle]="order.ShopName ? {'color':'#EC5228'} : {'color': '#673AB7'}">
                                                    <i *ngIf="!order.ShopName" class="bi bi-person"></i>
                                                    <i *ngIf="order.ShopName" class="bi bi-shop-window"></i>
                                                </div>
                                                <span class="half-ellipsis" style="width: fit-content;"
                                                    *ngIf="!order.ShopName && order.ContactPerson.split(' : ')[0]">{{order.ContactPerson.split('
                                                    : ')[0]}}</span>
                                                <span class="half-ellipsis" style="width: fit-content;"
                                                    *ngIf="order.ShopName">{{order.ShopName}}</span>
                                            </div>
                                            <div *ngIf="order.ContactPerson.split(' : ')[1]"
                                                class="contact-person d-flex align-items-center"
                                                [ngStyle]="order.ShopName ? {'color': '#EC5228'} : {'color': '#673AB7'}">
                                                <div class="shop-customer-logo "
                                                    [ngStyle]="order.ShopName ? {'color':'#EC5228'} : {'color': '#673AB7'}">
                                                    <i class="bi bi-telephone-fill"></i>
                                                </div>
                                                <span>{{order.ContactPerson.split(' : ')[1]}}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="d-flex overflow-hidden footer">
                                        <div class="w-100 d-flex">
                                            <div class="flex-shrink-1 flex-grow-1 pr-1 d-flex align-content-center">
                                                <span class="label"style="font-size: 0.8rem;">
                                                    {{moment(order.CreatedOn).format('DD/MMM/YY hh:mma')}}
                                                </span>
                                            </div>
                                            <div class="d-flex justify-content-end align-items-center flex-grow-1">
                                                <div class="d-flex align-items-center work-code pl-2"
                                                    [ngStyle]="{ 'background-color': lightenColor(order.StatusColour,0.2) , 'border': '1px solid ' + order.StatusColour, 'color': order.StatusColour}">
                                                    <div class="flex-shrink-1 flex-grow-1 status-labeltruncate">
                                                        {{order.WorkStatus}}</div>
                                                    <div class="mx-1 flex-shrink-0 flex-grow-0">|</div>
                                                    <div class="flex-shrink-0">
                                                        {{order.WorkCode}}
                                                        <i class="bi bi-chevron-right ml-1"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </ng-container>
                <div *ngIf="(isLoading && !msg) || isLazyloading" class="px-2 h-100">
                    <div *ngFor="let i of [].constructor(skeletonCount)"
                        class="workorder-card skeleton p-2 mt-2 d-flex justify-content-between align-items-center"
                        style="gap:8px;">

                        <div class="day-container skeleton-box p-1 h-100">
                            <div class="d-flex flex-column justify-content-center align-items-center h-100">
                                <div class="skeleton-text short"></div>
                                <div class="skeleton-circle"></div>
                                <div class="skeleton-text short"></div>
                            </div>
                        </div>

                        <div class="w-100 h-100 d-flex align-items-center">
                            <div class="details d-flex flex-column justify-content-between gap-2 ml-1 h-100 w-100">
                                <div>
                                    <div class="skeleton-text"></div>
                                    <div class="skeleton-text"></div>
                                    <div class="d-flex align-items-center">
                                        <div class="skeleton-text short mr-1"></div>
                                        <div class="skeleton-text short"></div>
                                    </div>
                                </div>
                                <div class="skeleton-text very-short"></div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </ng-container>

        <div [ngClass]="this.privilegeService.getServicenearPrivilege('addJob',true) ? '': 'disabled-privilege' "
            (click)="navigateToAddJob()" class="floating-add-btn">+</div>
    </div>

</div>




<!-- Modal -->
<div class="modal fade custom-modal" id="staticBackdrop" data-backdrop="static" data-keyboard="false" tabindex="-1"
    aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="staticBackdropLabel">Filter</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <form [formGroup]="filterForm">

                    <ng-select placeholder="Select a shop" [items]="shopList" bindValue="BranchID"
                        bindLabel="ShopName" formControlName="shop" [searchable]="true" [clearable]="true">
                    </ng-select>

                    <div class="divider"></div>

                    <ng-select placeholder="Select a date" [items]="timeOptions" formControlName="time"
                        [searchable]="true" [clearable]="true">
                    </ng-select>

                    <div class="d-flex mt-2" *ngIf="filterForm.get('time')?.value === 'Custom'">
                        <input formControlName="fromDate" type="date" class="input-fields-q5 mr-1">
                        <input formControlName="toDate" type="date" class="input-fields-q5 ml-1">
                    </div>

                    <ng-select
                        [ngClass]="this.privilegeService.getServicenearPrivilege('disableUserFilter', false) ? 'disabled-privilege': '' "
                        class="mt-3" placeholder="Select a person" [items]="userList" formControlName="user"
                        [searchable]="true" bindLabel="Name" bindValue="UserID" [clearable]="true">
                    </ng-select>

                    <div [ngClass]="this.privilegeService.getServicenearPrivilege('disableUserFilter', false)  ? 'disabled-privilege': '' "
                        class="d-flex justify-content-end align-items-center mt-3">
                        <div class="mr-2">Filter By Assigned</div>
                        <label class="switch">
                            <input class="input-switch" formControlName="assignedOnly" type="checkbox">
                            <span class="slider"></span>
                        </label>
                    </div>

                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">Close</button>
                <button type="button" class="btn filter-btn " data-dismiss="modal"
                    (click)="FilterWorkOrders()">Filter</button>
            </div>
        </div>
    </div>
</div>